// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "PageDescription-module--cds--assistive-text--5b1e7";
export var cdsHideFeedback = "PageDescription-module--cds--hide-feedback--9758b";
export var cdsShowFeedback = "PageDescription-module--cds--show-feedback--e9a0f";
export var cdsSkeleton = "PageDescription-module--cds--skeleton--a636d";
export var cdsVisuallyHidden = "PageDescription-module--cds--visually-hidden--0d8dc";
export var pageDescription = "PageDescription-module--page-description--45135";